import Link from 'next/link';
import React from 'react';
import styled from 'styled-components';

import { Futura } from '~/styles';

export default function ({ badge, large = false, onClick }) {
  return (
    <Wrapper large={large}>
      <Title>バッジ</Title>
      <Main>
        <Image src={badge.image} alt='image-badge' />
        <Right>
          <RightTop>
            <Prefecture>{badge.prefecture}</Prefecture>
            <Area>{badge.area}</Area>
          </RightTop>
          <Link href={'/corp-furusato/1'}>
            <BadgeTitle>
              {badge.title}
              <LinkIcon src='/images/link-black.svg' />
            </BadgeTitle>
          </Link>
          <Description large={large}>{badge.description}</Description>
        </Right>
      </Main>
      {!large && <SeeMore onClick={onClick}>SEE MORE</SeeMore>}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  height: ${(props) => (props.large ? 'auto' : '235px')};
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  position: relative;

  ${(props) =>
    props.large &&
    `
    padding-bottom: 40px;
  `}
`;

const Title = styled.div`
  margin-top: 5px;
  margin-left: 10px;
  font-size: 12px;
  font-weight: bold;
  color: #2c2c2c;
`;

const Main = styled.div`
  padding: 15px 35px 0;
  display: flex;
  flex-direction: row;
`;

const Image = styled.img`
  width: 92px;
  height: 92px;
  border-radius: 9px;
`;

const Right = styled.div`
  margin-left: 35px;
`;

const RightTop = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Prefecture = styled.div`
  background: #000;
  width: 84px;
  height: 18px;
  text-align: center;
  line-height: 18px;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
`;

const Area = styled.div`
  margin-left: 12px;
  font-size: 12px;
  font-weight: bold;
  color: #000;
`;

const BadgeTitle = styled.div`
  font-size: 18px;
  line-height: 30px;
  text-decoration: underline;
  font-weight: bold;
`;

const LinkIcon = styled.img`
  margin-left: 10px;
  position: relative;
  top: 2px;
  width: 20px;
  height: 20px;
  text-decoration: none;
`;

const Description = styled.div`
  margin-top: 10px;
  font-size: 18px;
  line-height: 32px;
  overflow: hidden;
  color: #070707;
  letter-spacing: 1px;
  white-space: ${(props) => (props.large ? 'pre-wrap' : 'normal')};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
`;

const SeeMore = styled(Futura)`
  position: absolute;
  font-size: 15px;
  text-decoration: underline;
  display: block;
  cursor: pointer;
  z-index: 1;
  left: 35px;
  bottom: 10px;
`;
